import { AppTabsMenuContainer, MenuItem } from './styles';

interface AppTabsMenuProps {
  items: AppTabsMenuItem[];
}

interface AppTabsMenuItem {
  label: string;
  isSelected?: boolean;
  action: () => void;
}

export const AppTabsMenu = ({ items }: AppTabsMenuProps) => {
  return (
    <AppTabsMenuContainer>
      <ul id="step-switch-apps-menu">
        {items.map((item) => {
          return (
            <MenuItem
              isSelected={item.isSelected}
              onClick={item.action}
              text={item.label}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </ul>
    </AppTabsMenuContainer>
  );
};
